module.exports = __webpack_public_path__ + "img/ic_yikaipiao.d743843b.svg";